import { CallSite, reflect } from 'typescript-rtti';
// can't use the <I> directly, need to use CallSite reflection:
// https://github.com/typescript-rtti/typescript-rtti#call-site-reflection
export function getPropNames<TInterface>(callSite?: CallSite) {
    const typeParam = reflect(callSite as CallSite).typeParameters[0];
    const reflectedInterface = typeParam.as('interface').reflectedInterface;
    const propertyNames = reflectedInterface.propertyNames;
    return propertyNames;
}
